
<div>
    <iui-messages id="message" #message  class="ms-auto me-auto"></iui-messages>
</div>
<div class="container-fluid mb-4">
    <div class="row">
        <div class="col-md-8">
            <h4 id="headerLabel">Consumer Complaints Summary</h4>
        </div>
        <div class="col-md-4">
            <button class="btn btn-primary" (click)="onDownload()">Download Month by Month Summary Report</button>
        </div>
        <div>
            <h5> No new data will be available for this report after 10/15/2024</h5>
        </div>
        <h5 class="col-12 mt-3">Summary Report Date</h5>
        <div class="col-4">
            <p-dropdown appDd id="supportSummaryDate" [(ngModel)]="summaryFilter.selection" (ngModelChange)="onChangeSelection()" name="supportSummaryDate" placeholder="Support Summary Date" [options]="dateRanges">
            </p-dropdown>
        </div>
        <div class="col-12 mt-3" *ngIf="summaryFilter.selection === 'DateRange'">
            <h5>Date Range</h5>
            <div class="row mt-2 mb-4">
                <div class="col-2">
                    <label for="summaryStartDate">Start</label>
                    <div>
                        <p-calendar placeholder="Start Date" [showIcon]="true" view="month" yearRange="2000:2100" [maxDate]="today"
                         dateFormat="mm/yy" [yearNavigator]="true" inputId="summarystartDate" name="summaryStartDate" [(ngModel)]="summaryFilter.startDate"></p-calendar>
                    </div>
                </div>
                <div class="col-2">
                    <label for="summaryDate">End </label>
                    <div>
                        <p-calendar placeholder="End Date" [showIcon]="true" view="month" yearRange="2000:2100" [maxDate]="today"
                         dateFormat="mm/yy" [yearNavigator]="true" inputId="summaryDate" name="summaryEndDate" [(ngModel)]="summaryFilter.endDate" [disabled]="!summaryFilter.startDate"></p-calendar>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <button class="btn btn-primary me-3" (click)="submitQuery()">Get Report</button>
            <button class="btn btn-secondary ms-3" (click)="clearQuery()">Reset Query</button>
        </div>
        <div class="col-8 mt-3" *ngIf="summaryData?.length">
            <h5>{{selectionName}} Results</h5>
            <p-table styleClass="p-datatable-striped" id="summaryData" [columns]="summaryColumns" [value]="summaryData" [scrollable]="true" scrollHeight="50vh">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" class="noBorder">
                            <strong>{{col.header}}</strong>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
                    <tr>
                        <ng-container *ngIf="!index">
                            <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                                <strong>{{rowData[col.field]}}</strong>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="index">
                            <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                                <div *ngSwitchCase="'riskType'" class="ps-4">{{rowData[col.field]}}</div>
                                <div *ngSwitchDefault>{{rowData[col.field]}}</div>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length" class="noBorder">
                            <b>No Data.</b>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="row">
        <div class="col-md-8">
            <h4 id="headerLabel">Consumer Complaints Search </h4>
        </div>
        <div class="col-md-8">
            <h5> No new data will be available for this report after 10/15/2024</h5>
        </div>
    </div>
    <div>
        <form #cccForm="ngForm" name="cccForm" (ngSubmit)="submit()">
            <div class="row mt-2 mb-4">
                <div class="col-2">
                    <label for="shortCode">Short Code</label>
                    <input placeholder="Short Code" type="text" id="shortCode" class="form-control form-text" name="shortCode" appAlphaNumOnly maxlength="{{MaxLen.ShortCode}}" 
                    [(ngModel)]="cccRequest.shortCode" /> 
                </div>

            </div>
            <div>
                <h5>Date Range</h5>
            </div>
            <div class="row mt-2 mb-4">
                <div class="col-2">
                    <label for="startDate">Start</label>
                    <div>
                        <p-calendar placeholder="Start Date" [showIcon]="true" inputId="startDate" name="startDate"
                        [(ngModel)]="cccRequest.startDate" dateFormat="yy-mm-dd" [maxDate]="today"></p-calendar>
                    </div>
                    
                </div>
                <div class="col-2">
                    <label for="endDate">End </label>
                    <div>
                        <p-calendar placeholder="End Date" [showIcon]="true" inputId="endDate" name="endDate"
                        [(ngModel)]="cccRequest.endDate" dateFormat="yy-mm-dd" [maxDate]="today" [disabled]="!cccRequest.startDate"></p-calendar>
                    </div>
                   
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-3">
                    <h5>Risk Types</h5>
                    <p-multiSelect [options]="riskTypes" id="auditType" appTid class="p-formcontrol" [(ngModel)]="cccRequest.riskTypes"  
                        name="riskTypes" placeholder="Nothing Selected" optionLabel="name" optionValue="name" selectedItemsLabel="{0} items selected" 
                        [maxSelectedLabels]="2" appendTo="body"></p-multiSelect>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12">
                    <button class="btn btn-primary" submit>Get Report</button>
                    <button type="button" class="btn btn-secondary ms-3" (click)="onReset()">Reset Query</button>
                </div>
            </div>
        </form>
    </div>
    <div class="row" *ngIf="showData">
        <div class="col-12">
           <h5 *ngIf="results.length">Results</h5>
            <p-table #complaintTable
                [columns]="tableColumn" 
                [value]="results"
                [paginator]="true"
                [rows]="rowsInPage"
                [alwaysShowPaginator]="false"
                [scrollable]="true" scrollHeight="50vh"
               currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})"
               [showCurrentPageReport]="true"
              [lazy]="true" [totalRecords]='totalRecords'  (onPage)="paginateComplaint($event)" >
                <ng-template pTemplate="header" let-columns>
                    <tr *ngIf="results.length > 0">
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="!col.sort" [style.width.%]="col.width" >{{col.header}}</th>
                            <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field" >
                                {{col.header}}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" >
                    <tr>
                        <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                            <div *ngSwitchCase="'shortCode'">
                                <a href="javascript:void(0)" (click)="navigateLookup(rowData)">{{rowData[col.field]}}</a>
                            </div>
                            <div *ngSwitchDefault class="ellipsis">{{rowData[col.field]}}</div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length" class="noBorder">
                            <b>No Records found.</b>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
